/**
 * Shader Property type.
 */
export enum ShaderPropertyType {
  /** Float type. */
  Float,
  /** Int type. */
  Int,
  /** Vector2 type. */
  Vector2,
  /** Vector3 type. */
  Vector3,
  /** Vector4 type. */
  Vector4,
  /** Matrix type. */
  Matrix,
  /** Color type. */
  Color,
  /** Texture type. */
  Texture,
  /** Float array type. */
  FloatArray,
  /** Int array type. */
  IntArray,
  /** Texture array type. */
  TextureArray
}
